import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Button, Icon} from 'kpc';

var _$tmp0 = {
    'className': 'k-icon-search'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Button, {
            'disabled': true,
            'children': 'disabled'
        }),
        _$cc(Button, {
            'disabled': true,
            'icon': true,
            'circle': true,
            'children': (
                _$cc(Icon, _$tmp0)
            )
        }),
        _$cc(Button, {
            'type': 'primary',
            'disabled': true,
            'children': 'primary'
        }),
        _$cc(Button, {
            'type': 'secondary',
            'disabled': true,
            'children': 'secondary'
        }),
        _$cc(Button, {
            'type': 'warning',
            'disabled': true,
            'children': 'warning'
        }),
        _$cc(Button, {
            'type': 'danger',
            'disabled': true,
            'children': 'danger'
        }),
        _$cc(Button, {
            'type': 'success',
            'disabled': true,
            'children': 'success'
        }),
        _$cc(Button, {
            'type': 'none',
            'disabled': true,
            'children': 'none'
        }),
        _$cc(Button, {
            'type': 'link',
            'disabled': true,
            'children': 'link'
        }),
        _$cc(Button, {
            'type': 'flat',
            'disabled': true,
            'children': 'flat'
        }),
        _$cc(Button, {
            'color': 'red',
            'disabled': true,
            'children': 'custom'
        })
    ], 4 /* HasNonKeyedChildren */);
};